import DataGrid, { Column, Grouping, GroupPanel, Pager, Paging, SearchPanel,GroupItem,Summary, FilterRow  } from 'devextreme-react/data-grid';
import { KeepStockSelector, getKeepStock } from '../../store/reducers/Report/keepStock'
import { useSelector, useDispatch } from 'react-redux'
import 'devextreme/dist/css/dx.light.css';
import React, { useState, useContext, useEffect } from 'react';
import { Spin } from 'antd';
const pageSizes = [10, 20, 50, 100, 500];

function TonKhoGiuHang() {
    const dispatch = useDispatch()
    const KeepStockSelectors = useSelector(KeepStockSelector)

    useEffect(() => {
        dispatch(getKeepStock())
    }, [])
    console.log(KeepStockSelectors.allPageLoad)
    return (
        <>
            <Spin tip="Loading..." spinning={KeepStockSelectors.Loading}>
                <div className="dx-viewport"  style={{backgroundColor: 'white', padding: '10px'}}>
                    <DataGrid dataSource={KeepStockSelectors.allPageLoad}
                        allowColumnReordering={true}
                        rowAlternationEnabled={true}
                        showBorders={true}
                        columnAutoWidth={true}>
                        <FilterRow visible={true} />
                        <GroupPanel visible={false} />
                        <SearchPanel visible={true} highlightCaseSensitive={true} width={200} />
                        <Grouping autoExpandAll={true} />
                        
                        <Column dataField="ItemCode" caption={"Mã hàng"} dataType="string" groupIndex={0}/>
                        <Column dataField="WhsName" caption={"Tên kho"} dataType="string" groupIndex={1}/>
                        <Column dataField="ItemName" caption={"Tên hàng"} dataType="string" />
                        <Column dataField="InDate" caption={"Ngày nhập"} dataType="date" format={"dd/MM/yyyy"}/>
                        <Column dataField="DistNumber" caption={"Số lô"} dataType="string" />
                        <Column dataField="Quantity" caption={"Tồn kho"} dataType="number" format={"#,###,###.####"} />
                        <Column dataField="QuantityRegis" caption={"Đã đăng ký"} dataType="number" format={"#,###,###.####"} />
                        <Column dataField="SumQuantityRegis" caption={"Tổng ĐK"} dataType="number" format={"#,###,###.####"} />
                        <Column dataField="AvailableQty" caption={"SL còn lại"} dataType="number" format={"#,###,###.####"} />
                        <Column dataField="DangHang" caption={"Loại"} dataType="string" />
                        <Column dataField="U_Pro_5" caption={"ĐL"} dataType="number" format={"#,###,###.##"} />
                        <Column dataField="U_Pro_6" caption={"Chiều rộng"} dataType="number" format={"#,###,###.##"} />
                        <Column dataField="U_Length" caption={"Chiều dài"} dataType="number" format={"#,###,###.##"} />
                        <Column dataField="U_Pro_2" caption={"Loại giấy"} dataType="string" />
                        <Column dataField="U_Pro_3" caption={"Tính chất"} dataType="string" />
                        <Column dataField="U_Pro_4" caption={"Nhãn hàng"} dataType="string" />
                        <Column dataField="ItmsGrpNam" caption={"Nhóm hàng"} dataType="string" />
                        <Column dataField="U_S1No" caption={"Số lệnh"} dataType="string" />
                        <Column dataField="CardName" caption={"Khách hàng"} dataType="string" />
                        <Column dataField="U_Seal" caption={"Seal"} dataType="string" />
                        <Column dataField="U_Cont" caption={"Cont"} dataType="string" />

                        <Summary>
                            <GroupItem
                                column="Quantity"
                                summaryType="sum"
                                valueFormat="###,###,###.####"
                                showInGroupFooter={false}
                                alignByColumn={true} />
                                <GroupItem
                                column="QuantityRegis"
                                summaryType="sum"
                                valueFormat="###,###,###.####"
                                showInGroupFooter={false}
                                alignByColumn={true} />
                        </Summary>

                        <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                        <Paging defaultPageSize={50} />
                    </DataGrid>
                </div>
            </Spin>
        </>
    );
}

export default TonKhoGiuHang;